import Quill from 'quill';

const Video = Quill.import('formats/video');
const Link = Quill.import('formats/link');

export default class CustomVideo extends Video {
	static create(value) {
		if (value.indexOf('www.youtube.com') > -1) {
			const node = document.createElement('div');
			node.setAttribute('className', 'ql-video');
			node.setAttribute(
				'style',
				'position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden;'
			);
			const video = document.createElement('iframe');
			video.setAttribute('controls', 'true');
			video.setAttribute('type', 'video/mp4');
			video.setAttribute('style', 'height: 100%; width: 100%; position: absolute; top: 0; left: 0;');
			video.setAttribute('src', value);
			node.appendChild(video);

			return node;
		} else {
			const node = super.create(value);
			const video = document.createElement('video');
			node.setAttribute('controls', true);
			node.setAttribute('type', 'video/mp4');
			node.setAttribute('src', this.sanitize(value));
			node.appendChild(video);
			return node;

		}
	}

	static sanitize(url) {
		return Link.sanitize(url);
	}
};
